import { watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthenticationStore } from '@cplug/frontend-shared-domains/domain/authentication'
import { resetHeaderCompanySelectSession } from '~/domain/shared/navigation/composables/useHeaderCompanySelectSession'
import useStoreSettingsStore from '~/domain/dashboard/store/stores/useStoreSettingsStore'
import useLegalTermStore from '~/domain/dashboard/app/apps/stores/useLegalTermStore'

export function useTenantStoreReset (): void {
  const authStore = useAuthenticationStore()
  const { companies, logged } = storeToRefs(authStore)

  const resetTenantStores = (): void => {
    useStoreSettingsStore().invalidate()
    useLegalTermStore().resetCache()
  }

  watch(
    () => companies.value[0]?.id,
    (companyId, previousCompanyId) => {
      if (companyId !== previousCompanyId) {
        resetTenantStores()
      }
    }
  )

  watch(logged, (isLogged) => {
    if (!isLogged) {
      resetTenantStores()
      resetHeaderCompanySelectSession()
    }
  })
}
